<template>
  <div class="headTitle">
    <van-row class="vanRow">
      <van-col span="4">
        <van-icon name="arrow-left" size="24" @click="goBack" />
      </van-col>
      <van-col span="16">
        <div class="titleBox">{{ topTitle || $route.meta.title }}</div></van-col
      >
      <van-col span="4"></van-col>
    </van-row>
  </div>
</template> 
<script>
export default {
  name: "HeadTitle",
  props: {
    topTitle: {
      type: String,
    },
    url: {
      type: String,
    },
  },
  data() {
    return {};
  },
  methods: {
    goBack() {
      if (this.url) {
        this.$router.push({ path: this.url });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>
<style scoped lang="less" >
.headTitle {
  width: 100%;
  height: 100px;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 10;
  background: rgb(72, 113, 192);
  color: white;
  font-size: 36px;
  line-height: 100px;
  .vanRow {
    width: 100%;
    height: 100px;
    .titleBox {
      text-align: center;
    }
  }
}
</style>